module.exports = __webpack_public_path__ + "pc-top-assets/img/logo-white.020ba773.svg";